import React, { Fragment } from 'react';
import { RelatedCategory } from '../../components/';

export default class RelatedCategoryContainer extends React.Component {
  constructor(props) {
    super(props);
    const rsWebProductModel = window.rs.web.product.model;
    this.state = {
      labels: rsWebProductModel.labels,
      relatedCategories: rsWebProductModel.relatedCategories,
      showShowHideLink: false,
      accordionHeight: 'initial',
      isExpanded: false,
      actualHeight: null,
    };
  }

  componentDidMount() {
    const height = this.getClientHeight();
    if (height > 40) {
      this.setState({ accordionHeight: this.defaultHeight, showShowHideLink: true, actualHeight: height });
    }
  }

  getClientHeight() {
    if (this.divElement) {
      return this.divElement.clientHeight;
    }
    return 0;
  }

  defaultHeight = '40px';

  showHide = () =>
    this.setState(state => ({
      accordionHeight: !state.isExpanded ? state.actualHeight : this.defaultHeight,
      isExpanded: !state.isExpanded,
    }));


  render() {
    return (
      this.state.relatedCategories && this.state.relatedCategories.length > 0 &&
      <Fragment>
        <div className="product-relatedcategories-heading">{this.state.labels.relatedCategories}</div>
        <div
          className="read-more-wrap"
          style={{ height: this.state.accordionHeight }}
          ref={divElement => {
            this.divElement = divElement;
          }}
        >
          {
            this.state.relatedCategories.map(item =>
              <RelatedCategory key={item.categoryName} {...item} />,
            )
          }
        </div>
        {this.state.showShowHideLink &&
        <Fragment>
          <a role="button" tabIndex={-99999} onClick={this.showHide} className="read-more-trigger">
            {this.state.isExpanded ? this.state.labels.showLess : this.state.labels.showMore}
          </a>
          <span className={`related-category-chevron ${!this.state.isExpanded ? 'more' : 'less'}`} />
        </Fragment>}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/containers/RelatedCategory/RelatedCategory.js